import Map from './map.tsx';

export default Map;
